import React from "react";
import { IUser } from "../../../../api/homesites/homesites.types";
import { HomeSitesDataIndex } from "../../../../reactQuery/homeSitesDataIndex/types";
import { ConfirmDialog } from "./ConfirmDialog";

interface UnassignConfirmDialogProps {
     open: boolean;
     selectedBulkConcierge: IUser | null;
     communityToUnassign: string;
     homesites: HomeSitesDataIndex[];
     isBulkAssigning: boolean;
     onConfirm: () => void;
     onCancel: () => void;
}

export const UnassignConfirmDialog: React.FC<UnassignConfirmDialogProps> = ({
     open,
     selectedBulkConcierge,
     communityToUnassign,
     homesites,
     isBulkAssigning,
     onConfirm,
     onCancel,
}) => {
     const homesitesToUpdate = homesites?.filter((hs) => hs.communityName === communityToUnassign) || [];
     const homesitesNeedingUpdate = homesitesToUpdate.filter(
          (hs) =>
               hs.conciergeSource !== "SF Opportunity" &&
               hs.conciergeName === selectedBulkConcierge?.name &&
               hs.conciergeEmail === selectedBulkConcierge?.email
     );

     const message = (
          <>
               Are you sure you want to unassign <strong>{selectedBulkConcierge?.name}</strong> from <strong>{communityToUnassign}</strong>?
               {homesitesNeedingUpdate.length > 0 && (
                    <span> This will unassign {homesitesNeedingUpdate.length} homesite{homesitesNeedingUpdate.length === 1 ? "" : "s"}.</span>
               )}
          </>
     );

     return (
          <ConfirmDialog
               open={open}
               title="Unassign Concierge from Community"
               message={message}
               isProcessing={isBulkAssigning}
               onConfirm={onConfirm}
               onCancel={onCancel}
          />
     );
};
